import { abnRegex } from '@shared/constants';
import { Input } from 'antd';
import type { Rule } from 'antd/es/form';

export const abnInputRule: Rule = {
    pattern: abnRegex,
    message: 'ABN must contain 11 digits (for example: 12345678901)',
};

export function AbnInput({
    onChange,
    ...props
}: {
    value?: string;
    onChange?: (value: string | null) => void;
    autoFocus?: boolean;
    disabled?: boolean;
}) {
    return (
        // Didn't add maxLength prop to Input, because in case user trying to paste
        // formatted ABN (with spaces) Input will paste only allowed length and cut the rest of chars.
        <Input
            onChange={(e) => onChange?.(e.target.value.trim() ? e.target.value.replace(/\D/g, '') : null)}
            {...props}
        />
    );
}
